
import api from './api';

class Email {

	constructor (Api) {
		this.Api = Api;
	}

	getBounced (query) {
		return this.Api.get({
			url:  'v1.1/m/emails/bounced',
			query
		});
	}

	getOptOuts (query) {
		return this.Api.get({
			url:  'v1.1/m/emails/optouts',
			query
		});
	}

}

Email.$inject = ['Api'];

export default angular.module('service.email', [api])
	.service('Email', Email)
	.name;



// WEBPACK FOOTER //
// ./src/service/email.js